module.exports = (window.__MEEGO_GLOBAL__?.loadRemoteEntryContainer?.('@meego-remote/expression') || new Promise(resolve => {
      const proxy = {
        get: async (request) => {
            const mod = await window['meego_remote_expression'].get(request);
            const res = await mod();
            return () => res;
        },
        init: (arg) => {
          try {
            window['meego_remote_expression'].init(arg);
          } catch(e) {
            console.log('remote container already initialized')
          }
        }
      };
      if (window['meego_remote_expression']) {
        resolve(proxy);
        return;
      }
      const createScript = function(remoteUrl) {
        const script = document.createElement('script')
        script.src = remoteUrl;
        script.onload = () => {
          resolve(proxy)
        }
        document.head.appendChild(script);
      };
      if (window.__MEEGO_REMOTE_MANIFESTS_SSG__?.meego_remote_expression?.remoteEntry?.url) {
        createScript(/^https/.test(window.__MEEGO_REMOTE_MANIFESTS_SSG__?.meego_remote_expression?.remoteEntry?.url) ? window.__MEEGO_REMOTE_MANIFESTS_SSG__?.meego_remote_expression?.remoteEntry?.url : ('https:' + window.__MEEGO_REMOTE_MANIFESTS_SSG__?.meego_remote_expression?.remoteEntry?.url));
      } else if ('/b/expression/remote-module/mf-manifest.json') {
        fetch('/b/expression/remote-module/mf-manifest.json').then(res => res.json()).then(res => {
          if (res?.remoteEntry?.url) {
            createScript('https:' + res.remoteEntry.url);
          } else {
            throw new Error('拉取/b/expression/remote-module/mf-manifest.json内容异常')
          }
        });
      } else {
        fetch('/b/meego_project_fe/host/manifest').then(res => res.text()).then(res => {
          createScript('https:' + res);
        });
      }
    }))
    ;